import { Component, EventEmitter, Output } from '@angular/core';
import { DatosEnviosService } from '../../services/datos-envios.service';
import { FiltroEnvio } from 'src/app/shared/models/filtros';
import { Router } from '@angular/router';
import { DesplegableData } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';
import { TipoFiltro } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/tipo-filtro';

@Component({
  selector: 'app-envios-filtros-nuevos',
  templateUrl: './envios-filtros-nuevos.component.html',
  styleUrls: ['./envios-filtros-nuevos.component.css']
})
export class EnviosFiltrosNuevosComponent {

  estados: DesplegableData[] = [];
  estadoSeleccionado: DesplegableData;
  // @Output() filtrarEnvios: EventEmitter<string> = new EventEmitter<string>();
  @Output() filtrarEnvios: EventEmitter<FiltroEnvio> = new EventEmitter<FiltroEnvio>();

  constructor(private datosEnviosService: DatosEnviosService,
              private router: Router) {
                this.getListaEstados();
              }

  ngOnInit(): void {
    if(this.router.url.includes('incompletos')){
      this.estadoSeleccionado = this.estados.find(estado => estado.desc === 'Incompleto') || this.estados[0];
    } else if(this.datosEnviosService.filtros.length > 0){
      const filtroEstado = this.datosEnviosService.filtros.find(x => x.text === 'Estado');
      if(filtroEstado){
        if(filtroEstado.estado === 'TODOS'){
          this.estadoSeleccionado = this.estados.find(estado => estado.desc === 'Todos los estados') || this.estados[0];
        } else {
          this.estadoSeleccionado = this.estados.find(estado => estado.desc === filtroEstado.estado) || this.estados[0];
        }
      } else {
        this.estadoSeleccionado = this.estados[0];
      }
    } else {
      this.estadoSeleccionado = this.estados[0];
    }
  }

  getListaEstados() {
    this.estados = this.datosEnviosService.GetEstadosLista();
  }

  actualizaFiltroEstado(estadoSeleccionado: any){
    this.estadoSeleccionado = estadoSeleccionado;
    let tipo;
    if(this.estadoSeleccionado.desc === 'Todos los estados'){
      tipo = {id:'TODOS', desc:'TODOS'}
    } else {
      tipo = this.estadoSeleccionado;
    }

    // const filtroEnvioSqp: FiltroSqp = {
    //   titulo: 'Estado',
    //   tipoFiltro: TipoFiltro.DESPLEGABLE,
    //   valoresSeleccionados: {
    //     valorString: tipo?.desc??''
    //   }
    // }

    const filtroEstado: FiltroEnvio = {
      text: 'Estado',
      textoBuscar: '',
      value: tipo?.desc??'',
      estado: tipo?.desc??'',
      idTipoEnvio: ""
    }

    // let existeEstado = this.datosEnviosService.filtros.findIndex(x=>x.text=='Estado')
    // if(existeEstado>-1) this.datosEnviosService.filtros[existeEstado] = filtroEstado;
    // else this.datosEnviosService.filtros.push(filtroEstado)

    // this.datosEnviosService.SetFilter(this.datosEnviosService.filtros);
    // this.datosEnviosService.Filter();

    this.filtrarEnvios.emit(filtroEstado);
  }

}
